import { FC, PropsWithChildren } from 'react';
import { ICON_NAMES, IImage } from '@belong/types';
import * as Heading from './SubDividerHeading.styles';

interface ISubDividerHeading {
  iconName?: ICON_NAMES;
  className?: string;
  image?: IImage;
}

export const SubDividerHeading: FC<PropsWithChildren<ISubDividerHeading>> = ({
  iconName,
  children,
  className,
  image
}: PropsWithChildren<ISubDividerHeading>) => {
  return (
    <Heading.Wrapper className={className}>
      {iconName && <Heading.IconStyled name={iconName} />}
      {children}
      {image && <Heading.Image {...image} src={[image.src as string, { h: 24 }]} />}
    </Heading.Wrapper>
  );
};

SubDividerHeading.displayName = 'SubDividerHeading';
